export const DYNAMIC_CALLER_ID_NAME = 'Dynamic Caller ID';
export const DYNAMIC_CALLER_ID_NUMBER = 'DYNAMIC_CALLER_ID_NUMBER';

export const DIRECT_LINE_NAME = 'Direct Line';
export const DYNAMIC_CALLER_ID_NUMBER_DISPLAY = '_';

export const DEFAULT_OUTBOUND_ID_NAME = 'Default Outbound ID';
